<template src="./ExternalProvider.html"></template>

<script>
import mixins from "../../../../../Mixins.js";
export default {
  name: "externalProvider",
  mixins: [mixins],
  data() {
    return { 
      planServices: [],
      planServicesFiltered: [],
      serviceFilter: "",
      defaultTableText: "Aguarde, estamos carregando as informações...",
      service: {
        id: null,
        name: "",
        partner: "",
        description: "",
      },
      invalid: {
        serviceName: false,
        servicePartner: false,
        serviceDescription: false,
      },
      modalTitle: "",
      disableModalEdit: false,
      enablePagination: true,
      windowWidth: 0,
      numPages: 1,
      currentx: 1,
      pagination: false,
    }
  },
  mounted: function() {
    this.init()
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize)
  },
  watch: {
    serviceFilter: function (string) {
      if (string === "") {
        this.enablePagination = true
        this.changePagination()
      }
      else {
        this.enablePagination = false
        this.planServicesFiltered = this.planServices.filter( 
            serv => (serv.name.toLowerCase().includes(string.toLowerCase()))
        ) 
      }
    },
    currentx: function () {
      this.changePagination();
    },
  },
  methods: {
    init() {
      this.getPlanServices()
    },
    getPlanServices() {
      this.axios.get(`${this.$store.state.filooServer}external-provider`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          this.defaultTableText = "Nenhum resultado encontrado"
          if (res.data.length > 0) {
            this.planServices = res.data
            this.planServicesFiltered = this.planServices
            this.numPages = Math.ceil(this.planServicesFiltered.length / 10)
            this.pagination = this.numPages > 1
            this.changePagination()
          }
        })
        .catch( err => {
          this.defaultTableText = "Nenhum resultado encontrado"
          console.log({
            endpointURL: "external-provider",
            error_getPlanServices: err,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao buscar a lista de Serviço de planos. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    checkFields() {
      let readyToUpdate = true
      if (!this.service.name) {
        this.invalid.serviceName = true
        readyToUpdate = false
      }
      if (readyToUpdate) this.updateService()
      else return false 
    },
    updateService() {     
      const method = this.service.id ? "put" : "post"
      const URLSuffix = method === "put" ? `/${this.service.id}` : "" 
      this.axios({
        method,
        url: `${this.$store.state.filooServer}external-provider`,
        data: {
          id: this.service.id,
          name: this.service.name
        }
      })
      .then( () => {
        this.$bvModal.hide("modal-register-new-service")
        const messagem = method === "post" ? 
          "Serviço de planos adicionado com sucesso!" : 
          "Serviço de planos atualizado com sucesso!"
        this.showNotifySuccess(
          "Sucesso", 
          messagem, 
          5000,
        )
        this.getPlanServices()
      })
      .catch( err => {
        console.log({
          endpointURL: `plan-services${URLSuffix}`,
          error_updateService: err,
        })
        this.$bvModal.hide("modal-register-new-service")
        this.showNotifyWarning(
          "Não foi possível realizar a transação. Por favor, tente novamente mais tarde!", 
          5000,
        )
      })
    },
    handleSelected(tr) {
      this.service = { ...null }
      this.service.id = tr.id
      this.modalTitle = "Editar Fornecedor"
      this.disableModalEdit = true
      this.$bvModal.show("modal-register-new-service")
      this.disableModalEdit = false
      this.service.name = tr.name
    },
    handleNewService() {
      this.service = { ...null }
      this.modalTitle = "Novo Fornecedor"
      this.$bvModal.show("modal-register-new-service")
    },
    changePagination() {
      const firstElement = (this.currentx - 1) * 10
      const lastElement = firstElement + 10
      this.planServicesFiltered = this.planServices.slice(firstElement , lastElement)
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
}
</script>

<style lang="scss" src="./ExternalProvider.scss">
</style> 